'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import {
  FC,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useMemo
} from 'react';

type navigationDrawersContext = {
  accountDrawer: ReturnType<typeof useDrawer>;
  sisDrawer: ReturnType<typeof useDrawer>;
  controlCenterOrOrderHistoryDrawer: ReturnType<typeof useDrawer>;
  getOpenDrawer: () => ReturnType<typeof useDrawer>;
};

const NavigationDrawersContext = createContext<navigationDrawersContext>(null);

export const useNavigationDrawers = () => useContext(NavigationDrawersContext);

export const NavigationDrawersProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const accountDrawer = useDrawer();
  const sisDrawer = useDrawer();
  const controlCenterOrOrderHistoryDrawer = useDrawer();

  const getOpenDrawer = useCallback(() => {
    const drawers = [
      accountDrawer,
      sisDrawer,
      controlCenterOrOrderHistoryDrawer
    ];

    const drawer = drawers.find((drawer) => drawer.isDrawerOpen);

    return drawer;
  }, [accountDrawer, controlCenterOrOrderHistoryDrawer, sisDrawer]);

  const drawers = useMemo(() => {
    return {
      accountDrawer,
      sisDrawer,
      controlCenterOrOrderHistoryDrawer,
      getOpenDrawer
    };
  }, [
    accountDrawer,
    sisDrawer,
    controlCenterOrOrderHistoryDrawer,
    getOpenDrawer
  ]);

  return (
    <NavigationDrawersContext.Provider value={drawers}>
      {children}
    </NavigationDrawersContext.Provider>
  );
};
